import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const Security = props => (
    <SvgIcon {...props}>
        <path
            fillRule="evenodd"
            stroke="none"
            d="M11.073 0l4.922 1.883v8.404a1.617 1.617 0 00-1.447-1.051l-.048-.002c.31-3.451-.833-5.183-3.427-5.194h-.026C8.479 4.05 7.334 5.748 7.613 9.13l.009.103h-.008c-.882 0-1.599.706-1.616 1.584v4.273c0 .337.103.65.28.909H2.242a1.605 1.605 0 01-.323-.127c-.797-1.877-.865-3.885-.869-5.082V5.167l.001-.22c.014-1.329.127-1.523.946-1.825l.278-.1c.96-.338 3.893-1.345 8.798-3.022zm.024 11.052a.96.96 0 01.96.932V14.26a.96.96 0 01-1.919 0V11.984a.96.96 0 01.96-.932zm-.038-5.183l.028.001c1.133.049 1.707.631 1.72 1.747v1.617H9.313V7.657c0-1.129.56-1.724 1.68-1.785l.066-.003z"
        />
    </SvgIcon>
);

export default Security;
